/* Anime-Pass — product page
   ---------------------------------------------------------
   Self-contained variant engine. This theme is missing Dawn's
   product-info.js / product-form.js, so nothing here depends on them.

   Prices arrive pre-formatted from Liquid (money filter), so no
   currency formatting happens client-side.

   Without JS the form still posts to /cart/add and the browser
   navigates to the cart — the page degrades rather than breaking. */
(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('[data-ap-variant-data]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var form = root.querySelector('[data-ap-product-form]');
    var idInput = root.querySelector('[data-ap-variant-id]');
    var priceEl = root.querySelector('[data-ap-price]');
    var wasEl = root.querySelector('[data-ap-was]');
    var saveEl = root.querySelector('[data-ap-save]');
    var addBtn = root.querySelector('[data-ap-add]');
    var addLabel = root.querySelector('[data-ap-add-label]');
    var errorEl = root.querySelector('[data-ap-error]');
    var stickyPrice = root.querySelector('[data-ap-sticky-price]');
    var stickyVariant = root.querySelector('[data-ap-sticky-variant]');
    var stickyAdd = root.querySelector('[data-ap-sticky-add]');
    var stickyLabel = root.querySelector('[data-ap-sticky-label]');
    var stickyBar = root.querySelector('[data-ap-sticky]');
    var stickyBtnPrice = root.querySelector('[data-ap-sticky-btn-price]');
    var stickyErrorEl = root.querySelector('[data-ap-sticky-error]');
    var proofCount = root.querySelector('[data-ap-proof-count]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-ap-option]'));
    var meter = root.querySelector('[data-ap-meter]');
    var moneyFmt = root.getAttribute('data-ap-money-format') || '{{amount}}';
    var currentPriceCents = 0;

    /* ---------- Variant resolution ---------- */
    function selectedValues() {
      var out = [];
      inputs.forEach(function (i) {
        if (i.checked) out[parseInt(i.getAttribute('data-ap-option'), 10) - 1] = i.value;
      });
      return out;
    }

    function matches(variant, values) {
      for (var i = 0; i < values.length; i++) {
        if (values[i] === undefined) continue;
        if (variant.options[i] !== values[i]) return false;
      }
      return true;
    }

    function findVariant(values) {
      // A product with only a default variant renders no option inputs, so
      // `values` is empty while variant.options is ["Default Title"] — the
      // length check below would never match and every such product would
      // report itself Unavailable. Trust the server-rendered id instead.
      if (inputs.length === 0) {
        var current = idInput && idInput.value;
        for (var j = 0; j < variants.length; j++) {
          if (String(variants[j].id) === String(current)) return variants[j];
        }
        return variants[0] || null;
      }

      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.length === values.length && matches(variants[i], values)) {
          return variants[i];
        }
      }
      return null;
    }

    /* Disable option values that can't combine into a purchasable variant,
       holding the other positions fixed. */
    function updateAvailability(values) {
      inputs.forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-ap-option'), 10) - 1;
        var probe = values.slice();
        probe[pos] = input.value;
        var found = variants.filter(function (v) {
          return matches(v, probe);
        });
        var sellable = found.some(function (v) {
          return v.available;
        });
        input.disabled = found.length > 0 && !sellable;
      });
    }

    function setText(el, value) {
      if (el && value != null) el.textContent = value;
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.round(cents / 100).toString();
      var amountWithComma = amount.replace('.', ',');
      var amountNoDecimalsWithComma = amountNoDecimals;
      return moneyFmt
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma)
        .replace('{{amount_no_decimals}}', amountNoDecimals)
        .replace('{{amount}}', amount);
    }

    function getQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return Math.max(1, q || 1);
    }

    function updateStickyBtnPrice() {
      if (!stickyBtnPrice || !currentPriceCents) return;
      var total = currentPriceCents * getQty();
      stickyBtnPrice.textContent = ' · ' + formatMoney(total);
    }

    function updateMeter(variant) {
      if (!meter) return;
      var total = parseInt(meter.getAttribute('data-ap-drop-size'), 10);
      if (!total || variant.inventory === null) return;
      var remaining = Math.max(0, variant.inventory);
      var claimed = Math.max(0, total - remaining);
      var pct = Math.min(100, (claimed / total) * 100);
      var fill = meter.querySelector('[data-ap-meter-fill]');
      if (fill) fill.style.width = pct + '%';
      setText(meter.querySelector('[data-ap-meter-claimed]'), claimed);
      setText(meter.querySelector('[data-ap-meter-remaining]'), remaining);
      setText(proofCount, claimed);
    }

    function render() {
      var values = selectedValues();
      updateAvailability(values);

      var variant = findVariant(values);

      if (!variant) {
        if (idInput) idInput.value = '';
        if (addBtn) addBtn.disabled = true;
        setText(addLabel, addBtn ? addBtn.getAttribute('data-ap-unavailable') : '');
        return;
      }

      if (idInput) idInput.value = variant.id;
      setText(priceEl, variant.price);

      if (wasEl) {
        wasEl.hidden = !variant.compare_at;
        if (variant.compare_at) wasEl.textContent = variant.compare_at;
      }
      if (saveEl) {
        saveEl.hidden = !variant.save;
        if (variant.save) saveEl.textContent = saveEl.getAttribute('data-ap-save-prefix') + ' ' + variant.save;
      }
      currentPriceCents = variant.price_cents || 0;

      // Keep the sticky bar in step with the main buy row
      setText(stickyPrice, variant.price);
      setText(stickyVariant, variant.options.join(' / '));
      updateStickyBtnPrice();
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        setText(
          stickyLabel,
          variant.available
            ? stickyAdd.getAttribute('data-ap-label-add')
            : stickyAdd.getAttribute('data-ap-label-soldout')
        );
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        setText(
          addLabel,
          variant.available
            ? addBtn.getAttribute('data-ap-add-label-text')
            : addBtn.getAttribute('data-ap-soldout')
        );
      }

      // Show the media tied to this variant, if it has one
      if (variant.media_id) selectMedia(String(variant.media_id));

      updateMeter(variant);

      // Keep the URL shareable without adding history entries
      if (variant.url && window.history.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }
    }

    inputs.forEach(function (i) {
      i.addEventListener('change', render);
    });

    /* ---------- Gallery ---------- */
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ap-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ap-slide]'));
    var galleryStatus = root.querySelector('[data-ap-gallery-status]');

    function selectMedia(id) {
      var found = false;
      var activeIndex = -1;
      slides.forEach(function (s, i) {
        var on = s.getAttribute('data-ap-slide') === id;
        if (on) { found = true; activeIndex = i; }
        s.hidden = !on;
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-ap-thumb') === id ? 'true' : 'false');
      });
      if (galleryStatus && slides.length > 1) {
        galleryStatus.textContent = 'Image ' + (activeIndex + 1) + ' of ' + slides.length;
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        selectMedia(t.getAttribute('data-ap-thumb'));
      });
    });

    /* ---------- Swipe on main media ---------- */
    var mainMedia = root.querySelector('.main-media');
    if (mainMedia && slides.length > 1) {
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swiping = false;
      mainMedia.addEventListener('touchstart', function (e) {
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });
      mainMedia.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - swipeStartX;
        var dy = e.changedTouches[0].clientY - swipeStartY;
        if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
        var cur = -1;
        slides.forEach(function (s, i) { if (!s.hidden) cur = i; });
        var next = dx < 0 ? cur + 1 : cur - 1;
        if (next >= 0 && next < slides.length) {
          selectMedia(slides[next].getAttribute('data-ap-slide'));
        }
      }, { passive: true });
    }

    /* ---------- Lightbox ---------- */
    var lightbox = root.querySelector('[data-ap-lightbox]');
    var lbImg = lightbox && lightbox.querySelector('.lb-img');
    var lbClose = lightbox && lightbox.querySelector('[data-ap-lb-close]');
    var lbPrev = lightbox && lightbox.querySelector('[data-ap-lb-prev]');
    var lbNext = lightbox && lightbox.querySelector('[data-ap-lb-next]');
    var lbCounter = lightbox && lightbox.querySelector('[data-ap-lb-counter]');
    var lbIndex = 0;

    function openLightbox(idx) {
      if (!lightbox || !lbImg || !slides[idx]) return;
      lbIndex = idx;
      var img = slides[idx].querySelector('img');
      if (!img) return;
      lbImg.src = img.src;
      lbImg.alt = img.alt;
      if (lbCounter) lbCounter.textContent = (idx + 1) + ' / ' + slides.length;
      if (lbPrev) lbPrev.disabled = idx === 0;
      if (lbNext) lbNext.disabled = idx === slides.length - 1;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (lbClose) lbClose.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    if (mainMedia && lightbox) {
      mainMedia.addEventListener('click', function (e) {
        if (e.target.closest('.sticker-pd')) return;
        var cur = 0;
        slides.forEach(function (s, i) { if (!s.hidden) cur = i; });
        openLightbox(cur);
      });
      mainMedia.style.cursor = 'zoom-in';
    }

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('lb-backdrop')) closeLightbox();
      });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft' && lbIndex > 0) openLightbox(lbIndex - 1);
        if (e.key === 'ArrowRight' && lbIndex < slides.length - 1) openLightbox(lbIndex + 1);
      });
    }
    if (lbPrev) lbPrev.addEventListener('click', function () {
      if (lbIndex > 0) openLightbox(lbIndex - 1);
    });
    if (lbNext) lbNext.addEventListener('click', function () {
      if (lbIndex < slides.length - 1) openLightbox(lbIndex + 1);
    });

    // Lightbox swipe
    if (lightbox && slides.length > 1) {
      var lbSwipeX = 0;
      lightbox.addEventListener('touchstart', function (e) {
        lbSwipeX = e.touches[0].clientX;
      }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - lbSwipeX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0 && lbIndex < slides.length - 1) openLightbox(lbIndex + 1);
        if (dx > 0 && lbIndex > 0) openLightbox(lbIndex - 1);
      }, { passive: true });
    }

    /* ---------- Quantity ---------- */
    var qtyInput = root.querySelector('[data-ap-qty]');
    root.querySelectorAll('[data-ap-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-ap-qty-step'), 10);
        var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
        var next = (parseInt(qtyInput.value, 10) || min) + step;
        qtyInput.value = Math.max(min, next);
        updateStickyBtnPrice();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', updateStickyBtnPrice);
    }

    /* ---------- Add to cart ---------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        if (errorEl) errorEl.hidden = true;
        if (stickyErrorEl) stickyErrorEl.hidden = true;

        var body = new FormData(form);
        // Ask for the re-rendered drawer in the same round trip
        var section =
          (window.AnimePassCart && window.AnimePassCart.sectionId) || 'anime-pass-cart-drawer';
        body.append('sections', section);
        body.append('sections_url', window.location.pathname);

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            if (res.status) {
              var msg = res.description || res.message;
              if (errorEl) {
                errorEl.textContent = msg;
                errorEl.hidden = false;
              }
              if (stickyErrorEl && stickyBar && stickyBar.classList.contains('is-visible')) {
                stickyErrorEl.textContent = msg;
                stickyErrorEl.hidden = false;
              }
              return;
            }
            // The cart script owns rendering and opening — this only announces
            document.dispatchEvent(new CustomEvent('ap:cart:updated', { detail: res }));
          })
          .catch(function () {
            // Network failure — fall back to a normal navigation
            form.submit();
          })
          .finally(function () {
            if (addBtn) addBtn.disabled = false;
          });
      });
    }

    /* ---------- Sticky add-to-cart ---------- */
    var saQtyInput = root.querySelector('[data-ap-sa-qty]');

    if (saQtyInput && qtyInput) {
      function syncQty(src, dest) {
        var val = Math.max(1, parseInt(src.value, 10) || 1);
        dest.value = val;
      }
      saQtyInput.addEventListener('input', function () { syncQty(saQtyInput, qtyInput); });
      qtyInput.addEventListener('input', function () { syncQty(qtyInput, saQtyInput); });
    }

    root.querySelectorAll('[data-ap-sa-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!saQtyInput) return;
        var step = parseInt(btn.getAttribute('data-ap-sa-qty-step'), 10);
        var next = (parseInt(saQtyInput.value, 10) || 1) + step;
        var val = Math.max(1, next);
        saQtyInput.value = val;
        if (qtyInput) qtyInput.value = val;
        updateStickyBtnPrice();
      });
    });
    if (saQtyInput) {
      saQtyInput.addEventListener('input', function () {
        updateStickyBtnPrice();
      });
    }

    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    }

    // Reveal once payment icons (or buy row as fallback) scroll off the top.
    // Using payment icons works on bundle/gift-card templates that lack a
    // standard buy button.
    var stickyAnchor = root.querySelector('.pdp-payments') || root.querySelector('.buy-row');
    if (stickyBar && stickyAnchor && 'IntersectionObserver' in window) {
      if (root._apStickyObserver) root._apStickyObserver.disconnect();
      root._apStickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
            stickyBar.classList.toggle('is-visible', scrolledPast);
          });
        },
        { threshold: 0 }
      );
      root._apStickyObserver.observe(stickyAnchor);
    }

    render();

    if (galleryStatus && slides.length > 1) {
      var initialIndex = 0;
      slides.forEach(function (s, i) { if (!s.hidden) initialIndex = i; });
      galleryStatus.textContent = 'Image ' + (initialIndex + 1) + ' of ' + slides.length;
    }
  }

  function boot() {
    document.querySelectorAll('[data-ap-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ap-product]');
    if (root) init(root);
  });
})();
